export default theme => ({
	root: {
		margin: theme.spacing(1),
		flex: 1,
		minHeight: 200,
		'--image-width': '200px'
	},
	cardContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'flex-start',
	},
	content: {
		fontWeight: 'bold',
	},
});
